// src/auth/index.js
import { ref } from 'vue'

export const isLoggedIn = ref(false)

export const userPermissions = ref({
    enable_user_manage: false,
    enable_train: false,
    enable_inference: false,
    enable_annotation: false,
})

export const currentUser = ref('')


export function setAuthState({ username, permissions }) {
    isLoggedIn.value = true
    currentUser.value = username || ''
    userPermissions.value = {
        enable_user_manage: permissions?.enable_user_manage || false,
        enable_train: permissions?.enable_train || false,
        enable_inference: permissions?.enable_inference || false,
        enable_annotation: permissions?.enable_annotation || false
    }
}

export function resetAuthState() {
    isLoggedIn.value = false
    currentUser.value = ''
    userPermissions.value = {
        enable_user_manage: false,
        enable_train: false,
        enable_inference: false,
        enable_annotation: false
    }
}
